import { render, staticRenderFns } from "./demo-portal.vue?vue&type=template&id=5a3bf8e7"
import script from "./demo-portal.vue?vue&type=script&lang=js"
export * from "./demo-portal.vue?vue&type=script&lang=js"
import style0 from "./demo-portal.vue?vue&type=style&index=0&id=5a3bf8e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports